import useVendorContext from './context';
import VendorProvider from './provider';

export { VendorProvider };
export default useVendorContext;
